import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldInitSpec from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldSet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet2.js";
import _classPrivateFieldGet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import qs from "qs";
import axios from "axios";
import { Toast } from "@modules/toast";
import { Spinner } from "@modules/spinner";
import { Message } from "@modules/message";
import { Base } from "@services/base";
import { Navigation } from "@services/navigation";
import { AccountStorage } from "@services/account";
var accountStorage = new AccountStorage();
var _base = /*#__PURE__*/new WeakMap();
var _axios = /*#__PURE__*/new WeakMap();
var _navigation = /*#__PURE__*/new WeakMap();
var _axiosInstance = /*#__PURE__*/new WeakMap();
var _interceptors = /*#__PURE__*/new WeakMap();
var _options = /*#__PURE__*/new WeakMap();
var _requestOptions = /*#__PURE__*/new WeakMap();
var _requestIsTimeout = /*#__PURE__*/new WeakMap();
var _createRequest = /*#__PURE__*/new WeakMap();
var _createRequestId = /*#__PURE__*/new WeakMap();
var _responseFatmat = /*#__PURE__*/new WeakMap();
var _responseProcessor = /*#__PURE__*/new WeakMap();
var _createCancelTokenSource = /*#__PURE__*/new WeakMap();
var _registerDefaultInterceptor = /*#__PURE__*/new WeakMap();
var _defaultInterceptorRequestStart = /*#__PURE__*/new WeakMap();
var _defaultInterceptorResponseCatch = /*#__PURE__*/new WeakMap();
var _defaultInterceptorResponseSuccess = /*#__PURE__*/new WeakMap();
export var HttpClient = /*#__PURE__*/function () {
  function HttpClient() {
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, HttpClient);
    _classPrivateFieldInitSpec(this, _base, new Base());
    _classPrivateFieldInitSpec(this, _axios, axios);
    _classPrivateFieldInitSpec(this, _navigation, new Navigation());
    _classPrivateFieldInitSpec(this, _axiosInstance, void 0);
    _classPrivateFieldInitSpec(this, _interceptors, {
      request: [],
      response: []
    });
    _classPrivateFieldInitSpec(this, _options, {});
    _classPrivateFieldInitSpec(this, _requestOptions, {});
    _classPrivateFieldInitSpec(this, _requestIsTimeout, function (error) {
      return error.code === "ECONNABORTED" && error.message.indexOf("timeout") !== -1;
    });
    _classPrivateFieldInitSpec(this, _createRequest, function (_ref) {
      var method = _ref.method,
        url = _ref.url,
        data = _ref.data,
        _ref$config = _ref.config,
        config = _ref$config === void 0 ? {} : _ref$config;
      var id = _classPrivateFieldGet(_createRequestId, _this).call(_this);
      var source = _classPrivateFieldGet(_createCancelTokenSource, _this).call(_this);
      var request = 0;
      method = method.toLowerCase();
      config.headers || (config.headers = {});
      config.headers["Request-Id"] = id;
      config.headers["deviceType"] = 1; //pc端
      config.headers['system'] = 'PC';
      config.cancelToken = source.token;
      if (method === "request" || method === "getUri") {
        request = _classPrivateFieldGet(_axiosInstance, _this)[method](config);
      } else if (method === "get" || method === "head" || method === "delete" || method === "options") {
        request = _classPrivateFieldGet(_axiosInstance, _this)[method](url, config);
      } else if (method === "put" || method === "post" || method === "patch") {
        request = _classPrivateFieldGet(_axiosInstance, _this)[method](url, data, config);
      }
      var timer = {
        timeout: false,
        timestamp: 0
      };
      if (_classPrivateFieldGet(_options, _this).duration > 0) {
        timer.timestamp = setTimeout(function () {
          timer.timeout = true;
          clearTimeout(timer.timestamp);
        }, _classPrivateFieldGet(_options, _this).duration);
      }
      HttpClient.requests.set(id, [request, source.cancel, timer]);
      return request;
    });
    _classPrivateFieldInitSpec(this, _createRequestId, function () {
      return Math.floor(Math.random() * Math.pow(10, 18));
    });
    _classPrivateFieldInitSpec(this, _responseFatmat, function () {
      var responseData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var success = responseData.success;
      if ({}.toString.call(success) === "[object Boolean]") {
        if (success) {
          var content = responseData.content;
          if (content) {
            responseData.msg = "success";
            responseData.code = 200;
            responseData.data = content;
            delete responseData.content;
            delete responseData.success;
            return responseData;
          }
        } else {
          var message = responseData.message;
          if (message) {
            return {
              msg: message,
              code: 0
            };
          }
        }
      }
      return responseData;
    });
    _classPrivateFieldInitSpec(this, _responseProcessor, function (response) {
      var data = _classPrivateFieldGet(_responseFatmat, _this).call(_this, response.data);
      var code = +data.code;
      if (code === 401 || code === 403) {
        if (_classPrivateFieldGet(_options, _this).useResponseRedirectLogin) {
          // this.cancel();
          _classPrivateFieldGet(_navigation, _this).toLogin();
        }
      } else if (code === 302) {
        accountStorage.removeCacheUserInfo();
        accountStorage.removeCacheUserList();
        setTimeout(function () {
          window.location.href = data.msg;
        }, 50);
      } else if (code === 703) {
        _classPrivateFieldGet(_navigation, _this).toNotice();
      } else if (code === 195) {} else if (code == 429) {
        var ENV_APP = process.env.VUE_APP_API_SERVER;
        if (ENV_APP == "https://api.pujian.com") {
          window.location.href = "https://pay.pujian.com/verify.html?isApp=0&env=prd&token=" + accountStorage.getCacheAccessToken() || "";
        } else if (ENV_APP == "https://api-pre.pujian.com") {
          window.location.href = "https://pay-pre.pujian.com/verify.html?isApp=0&env=pre&token=" + accountStorage.getCacheAccessToken() || "";
        } else {
          window.location.href = "https://pay-uat.pujian.com/verify.html?isApp=0&env=uat&token=" + accountStorage.getCacheAccessToken() || "";
        }
      } else if (code == 423) {
        HttpClient.toast.instance.mount(HttpClient.toast.instance.create(data.msg), 10000);
        setTimeout(function () {
          _this.cancel();
          _classPrivateFieldGet(_navigation, _this).toLogin();
        }, 10000);
      } else if (code == 100001) {
        var messageMock = HttpClient.message.instance.get(code);
        var message = messageMock ? messageMock.statusText : data.msg || HttpClient.message.instance.get("0").statusText;
        HttpClient.toast.instance.mount(HttpClient.toast.instance.create(message), 3000);
      } else if (code == 100002) {
        // 判断托运客户返回状态码
        if (data.msg.indexOf('10009') === 0) return response;
        var _messageMock = HttpClient.message.instance.get(code);
        var _message = _messageMock ? _messageMock.statusText : data.msg || HttpClient.message.instance.get("0").statusText;
        HttpClient.toast.instance.mount(HttpClient.toast.instance.create(_message), 3000);
      } else if (code == 7777) {
        return response;
      } else if (code == 500) {
        var _message2 = '哎呀，系统出错了，请稍后再试~';
        HttpClient.toast.instance.mount(HttpClient.toast.instance.create(_message2), 3000);
      } else if (code !== 200) {
        if (_classPrivateFieldGet(_options, _this).useResponseToast) {
          var _messageMock2 = HttpClient.message.instance.get(code);
          var _message3 = _messageMock2 ? _messageMock2.statusText : data.msg || HttpClient.message.instance.get("0").statusText;
          if (code != 8501) {
            HttpClient.toast.instance.mount(HttpClient.toast.instance.create(_message3), 3000);
          }
        }
      }
      return response;
    });
    _classPrivateFieldInitSpec(this, _createCancelTokenSource, function () {
      var source = _classPrivateFieldGet(_axios, _this).CancelToken.source();
      var token = source.token;
      var cancel = source.cancel;
      return {
        token: token,
        cancel: cancel
      };
    });
    _classPrivateFieldInitSpec(this, _registerDefaultInterceptor, function () {
      _this.requestInterceptor.register(function (config) {
        return _classPrivateFieldGet(_defaultInterceptorRequestStart, _this).call(_this, config);
      });
      _this.responseInterceptor.register(function (response) {
        return _classPrivateFieldGet(_defaultInterceptorResponseSuccess, _this).call(_this, response);
      }, function (error) {
        return _classPrivateFieldGet(_defaultInterceptorResponseCatch, _this).call(_this, error);
      });
    });
    _classPrivateFieldInitSpec(this, _defaultInterceptorRequestStart, function (config) {
      if (_classPrivateFieldGet(_options, _this).useSpinner && config.useSpinner != false) {
        if (!HttpClient.spinner.instance.isMount()) {
          HttpClient.spinner.instance.mount(_classPrivateFieldGet(_options, _this).spinnerDelay);
        }
      }
      if (_classPrivateFieldGet(_options, _this).useDefaultParams) {
        var params = Object.assign({}, _classPrivateFieldGet(_requestOptions, _this).params);
        if (config.params && {}.toString.call(config.params) === "[object Object]") {
          config.params = Object.assign(params, config.params);
        } else {
          config.params = params;
        }
      }
      if (_classPrivateFieldGet(_options, _this).useDefaultData) {
        var data = Object.assign({}, _classPrivateFieldGet(_requestOptions, _this).data);
        if (config.data) {
          if ({}.toString.call(config.data) === "[object Object]") {
            config.data = Object.assign(data, config.data);
          } else if ({}.toString.call(config.data) === "[object String]") {
            config.data = qs.stringify(Object.assign(data, qs.parse(config.data)));
          }
        } else {
          config.data = data;
        }
      }
      return config;
    });
    _classPrivateFieldInitSpec(this, _defaultInterceptorResponseCatch, function (error) {
      if (_classPrivateFieldGet(_axios, _this).isCancel(error)) {
        error = error.message;
        var id = error.id;
        HttpClient.requests.has(id) && HttpClient.requests.delete(id);
        if (_classPrivateFieldGet(_options, _this).useSpinner) {
          if (HttpClient.requests.size === 0 && HttpClient.spinner.instance.isMount()) {
            HttpClient.spinner.instance.unmount();
          }
        }
        if (_classPrivateFieldGet(_options, _this).useRequestCancelToast) {
          var status = error.status;
          console.log('接口请求状态', status);
          var messageMock = HttpClient.message.instance.get(status);
          var message = messageMock ? messageMock.statusText : error.message || HttpClient.message.instance.get("0").statusText;
          HttpClient.toast.instance.mount(HttpClient.toast.instance.create(message));
        }
      } else {
        var _id = error.config.headers["Request-Id"];
        HttpClient.requests.has(_id) && HttpClient.requests.delete(_id);
        if (_classPrivateFieldGet(_options, _this).useSpinner) {
          if (HttpClient.requests.size === 0 && HttpClient.spinner.instance.isMount()) {
            HttpClient.spinner.instance.unmount();
          }
        }
        if (_classPrivateFieldGet(_requestIsTimeout, _this).call(_this, error)) {
          if (_classPrivateFieldGet(_options, _this).useRequestTimeoutToast) {
            var _status = "601";
            console.log('接口请求状态', _status);
            var _messageMock3 = HttpClient.message.instance.get(_status);
            var _message4 = _messageMock3 ? _messageMock3.statusText : error.message || HttpClient.message.instance.get("0").statusText;
            HttpClient.toast.instance.mount(HttpClient.toast.instance.create(_message4));
          }
        } else {
          if (_classPrivateFieldGet(_options, _this).useResponseCatchToast) {
            var _error$response;
            var _status2 = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
            console.log('接口请求状态', _status2);
            var _messageMock4 = HttpClient.message.instance.get(_status2);
            var _message5 = _messageMock4 ? _messageMock4.statusText : error.message || HttpClient.message.instance.get("0").statusText;
            HttpClient.toast.instance.mount(HttpClient.toast.instance.create(_message5));
          }
        }
      }
      return Promise.reject(error);
    });
    _classPrivateFieldInitSpec(this, _defaultInterceptorResponseSuccess, function (response) {
      var id = response.config.headers["Request-Id"];
      var timer = HttpClient.requests.get(id)[2];
      if (_classPrivateFieldGet(_options, _this).useSpinner) {
        if (_classPrivateFieldGet(_options, _this).duration > 0) {
          if (!timer.timeout) {
            return new Promise(function (resolve) {
              var createTimeoutHandler = function createTimeoutHandler() {
                var timestamp = setTimeout(function () {
                  clearTimeout(timestamp);
                  if (timer.timeout) {
                    HttpClient.requests.has(id) && HttpClient.requests.delete(id);
                    if (HttpClient.requests.size === 0 && HttpClient.spinner.instance.isMount()) {
                      HttpClient.spinner.instance.unmount();
                    }
                    return resolve(_classPrivateFieldGet(_responseProcessor, _this).call(_this, response));
                  } else {
                    createTimeoutHandler();
                  }
                }, 4);
              };
              createTimeoutHandler();
            });
          }
          return Promise.resolve(_classPrivateFieldGet(_responseProcessor, _this).call(_this, response));
        }
      }
      HttpClient.requests.has(id) && HttpClient.requests.delete(id);
      if (HttpClient.requests.size === 0 && HttpClient.spinner.instance.isMount()) {
        HttpClient.spinner.instance.unmount();
      }
      return Promise.resolve(_classPrivateFieldGet(_responseProcessor, _this).call(_this, response));
    });
    _defineProperty(this, "original", _classPrivateFieldGet(_axios, this));
    _defineProperty(this, "originalInstance", _classPrivateFieldGet(_axiosInstance, this));
    _defineProperty(this, "requestInterceptor", function () {
      var register = function register() {
        var _classPrivateFieldGet2;
        var interceptor = (_classPrivateFieldGet2 = _classPrivateFieldGet(_axiosInstance, _this).interceptors.request).use.apply(_classPrivateFieldGet2, arguments);
        _classPrivateFieldGet(_interceptors, _this).request.push(interceptor);
        return interceptor;
      };
      var cancel = function cancel(id) {
        var index = _classPrivateFieldGet(_interceptors, _this).request.indexOf(id);
        if (index > -1) {
          _classPrivateFieldGet(_interceptors, _this).request.splice(index, 1);
        }
        _classPrivateFieldGet(_axiosInstance, _this).interceptors.request.eject(id);
      };
      return {
        cancel: cancel,
        register: register
      };
    }());
    _defineProperty(this, "responseInterceptor", function () {
      var register = function register() {
        var _classPrivateFieldGet3;
        var interceptor = (_classPrivateFieldGet3 = _classPrivateFieldGet(_axiosInstance, _this).interceptors.response).use.apply(_classPrivateFieldGet3, arguments);
        _classPrivateFieldGet(_interceptors, _this).response.push(interceptor);
        return interceptor;
      };
      var cancel = function cancel(id) {
        var index = _classPrivateFieldGet(_interceptors, _this).response.indexOf(id);
        if (index > -1) {
          _classPrivateFieldGet(_interceptors, _this).response.splice(index, 1);
        }
        _classPrivateFieldGet(_axiosInstance, _this).interceptors.response.eject(id);
      };
      return {
        cancel: cancel,
        register: register
      };
    }());
    _classPrivateFieldSet(_options, this, Object.assign({}, HttpClient.options, options));
    if (requestOptions.headers) {
      requestOptions.headers = Object.assign({}, HttpClient.requestOptions.headers, requestOptions.headers);
    }
    _classPrivateFieldSet(_requestOptions, this, Object.assign({}, HttpClient.requestOptions, requestOptions));
    _classPrivateFieldSet(_axiosInstance, this, _classPrivateFieldGet(_axios, this).create(_classPrivateFieldGet(_requestOptions, this)));
    _classPrivateFieldGet(_registerDefaultInterceptor, this).call(this);
  }
  return _createClass(HttpClient, [{
    key: "setOptions",
    value: function setOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classPrivateFieldSet(_options, this, Object.assign(_classPrivateFieldGet(_options, this), options));
      return this;
    }
  }, {
    key: "setRequestOptions",
    value: function setRequestOptions() {
      var requestOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classPrivateFieldGet(_axiosInstance, this).defaults = _classPrivateFieldGet(_base, this).extend(_classPrivateFieldGet(_axiosInstance, this).defaults, requestOptions);
      return this;
    }
  }, {
    key: "cancel",
    value: function cancel(request) {
      if (request) {
        HttpClient.requests.forEach(function (item, index) {
          if (item[0] === request) {
            item[1]({
              id: index,
              status: 600,
              message: "请求已取消"
            });
          }
        });
      } else {
        HttpClient.requests.forEach(function (item, index) {
          item[1]({
            id: index,
            status: 600,
            message: "请求已取消"
          });
        });
      }
    }
  }, {
    key: "get",
    value: function get(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _classPrivateFieldGet(_createRequest, this).call(this, {
        url: url,
        config: config,
        method: "get"
      });
    }
  }, {
    key: "put",
    value: function put(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _classPrivateFieldGet(_createRequest, this).call(this, {
        url: url,
        data: data,
        config: config,
        method: "put"
      });
    }
  }, {
    key: "post",
    value: function post(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _classPrivateFieldGet(_createRequest, this).call(this, {
        url: url,
        data: data,
        config: config,
        method: "post"
      });
    }
  }, {
    key: "head",
    value: function head(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _classPrivateFieldGet(_createRequest, this).call(this, {
        url: url,
        config: config,
        method: "head"
      });
    }
  }, {
    key: "patch",
    value: function patch(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return _classPrivateFieldGet(_createRequest, this).call(this, {
        url: url,
        data: data,
        config: config,
        method: "patch"
      });
    }
  }, {
    key: "delete",
    value: function _delete(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _classPrivateFieldGet(_createRequest, this).call(this, {
        url: url,
        config: config,
        method: "delete"
      });
    }
  }, {
    key: "getUri",
    value: function getUri() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _classPrivateFieldGet(_createRequest, this).call(this, {
        config: config,
        method: "getUri"
      });
    }
  }, {
    key: "options",
    value: function options(url) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _classPrivateFieldGet(_createRequest, this).call(this, {
        url: url,
        config: config,
        method: "options"
      });
    }
  }, {
    key: "request",
    value: function request() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _classPrivateFieldGet(_createRequest, this).call(this, {
        config: config,
        method: "request"
      });
    }
  }]);
}();
_defineProperty(HttpClient, "requests", new Map());
_defineProperty(HttpClient, "options", {
  duration: 0,
  spinnerDelay: 200,
  useSpinner: true,
  useDefaultData: true,
  useDefaultParams: true,
  useResponseToast: true,
  useResponseCatchToast: true,
  useRequestCancelToast: false,
  useRequestTimeoutToast: true,
  useResponseRedirectLogin: true
});
_defineProperty(HttpClient, "requestOptions", {
  data: {},
  params: {},
  timeout: 5000,
  withCredentials: true,
  headers: {}
});
_defineProperty(HttpClient, "toast", {
  instance: new Toast()
});
_defineProperty(HttpClient, "spinner", {
  instance: new Spinner()
});
_defineProperty(HttpClient, "message", {
  instance: new Message()
});